import { MirageTheme } from "@mirage/theme/MuiMirage.module";
import { Skeleton, Typography } from "@mui/material";
import React from "react";
import "./TextNavigate.css";
import { useStableNavigate } from "@mirage/hooks/useStableNavigate";

interface TextNavigateProps {
    navigateTo?: string | null;
    text?: string;
    disabled?: boolean;
    isLoading?: boolean;
}

export const TextNavigate: React.FC<TextNavigateProps> = ({ text, navigateTo, isLoading, disabled = false }) => {
    const navigate = useStableNavigate();
    const disabledClass = disabled ? "-disabled" : "";
    if (text) {
        if (isLoading) {
            return <Skeleton variant="text" sx={{ maxWidth: "300px", marginBottom: "1rem" }} />;
        }
        return (
            <Typography variant="button" className={`textNavigate${disabledClass}`.trim()} style={{ color: MirageTheme.palette.primary.main }} onClick={handleOnClick}>
                {text}
            </Typography>
        );
    }
    return null;

    function handleOnClick() {
        if (navigateTo) {
            navigate(navigateTo);
        }
    }
};
